import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['María G.', 'Carmen L.', 'Ana P.', 'Laura M.', 'Elena S.', 'Isabel R.', 'Marta D.', 'Rosa C.'];
const locations = ['Madrid', 'Ciudad de México', 'Bogotá', 'Buenos Aires', 'Santiago', 'Lima', 'Miami', 'Valencia'];
export function RecentPurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: '',
    time: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setCurrentBuyer({
        name: randomName,
        location: randomLocation,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 10000);
    // Then show randomly every 20-40 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showNotification();
      }
    }, Math.floor(Math.random() * 20000) + 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-218">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-100 p-4 pr-10 flex items-start space-x-3 max-w-sm relative" data-id="element-219">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-220">
          <XIcon className="h-4 w-4" data-id="element-221" />
        </button>
        <div className="flex-shrink-0 mt-1" data-id="element-222">
          <CheckCircleIcon className="h-6 w-6 text-green-500" data-id="element-223" />
        </div>
        <div data-id="element-224">
          <p className="text-sm font-medium text-gray-900" data-id="element-225">
            {currentBuyer.name} de {currentBuyer.location}
          </p>
          <p className="text-xs text-gray-600 mt-0.5" data-id="element-226">
            Acaba de comprar el Protocolo de Reinicio de Cortisol
          </p>
          <p className="text-xs text-gray-400 mt-1 font-medium" data-id="element-227">
            {currentBuyer.time}
          </p>
        </div>
      </div>
    </div>;
}